
import { useState, useEffect, useMemo } from 'react'; // Added useMemo
import { useParams, useNavigate } from 'react-router-dom';
import { useFirebase } from '@/context/FirebaseProvider'; // Replaced useData
import { Business as BusinessZod } from '@/schemas/business'; // Use Zod type

export const useBusinessSettingsBase = (initialTab = 'billing') => {
  const { businessId } = useParams<{ businessId: string }>();
  const { businesses: allBusinessesFromFirebase } = useFirebase(); // Get businesses
  const navigate = useNavigate();
  
  const [activeTab, setActiveTab] = useState<string>(initialTab);
  
  const business = useMemo(() => {
    if (!businessId || !allBusinessesFromFirebase) return null;
    return allBusinessesFromFirebase.find(b => b.id === businessId) || null;
  }, [businessId, allBusinessesFromFirebase]);

  const allBusinesses = useMemo(() => {
    return allBusinessesFromFirebase || [];
  }, [allBusinessesFromFirebase]);
  
  // No longer need separate useState for business and allBusinesses, 
  // they are derived from FirebaseProvider via useMemo.
  // The useEffect that populated them is also no longer needed.

  const handleEditCampaign = () => {
    if (businessId) {
      navigate(`/business/${businessId}/gocampaign`);
    }
  };
  
  return {
    business,
    businessId, // Adding businessId to the return object
    activeTab,
    setActiveTab,
    navigate,
    handleEditCampaign,
    allBusinesses
  };
};
